<div class="upload-container">
  <input
    type="file"
    id="load-file"
    class="d-none"
    accept=".csv"
    (change)="onFileChange($event)"
  />
  <div class="list-container">
    @if (file()) {
      <div class="drag-box card d-flex flex-row align-items-center p-5">
        <div class="file-preview flex-auto d-flex gap-2 align-items-center">
          <ui-keenicon [name]="'file'" class="fs-1 text-primary"></ui-keenicon>
          <span class="file-name fs-6">{{ file()?.name }}</span>
        </div>
        <button
          class="btn btn-sm btn-bg-light d-inline-flex align-items-center delete-btn"
          (click)="removeFile()"
        >
          <ui-keenicon
            [name]="'cross-circle'"
            class="fs-3 text-danger"
          ></ui-keenicon>
        </button>
      </div>
    }

    @if (!file()) {
      <label
        for="load-file"
        class="card add-button-horizontal"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
      >
        <button
          class="btn add-button-icon btn-sm btn-bg-light d-flex align-items-center"
        >
          <ui-keenicon
            [name]="'plus-circle'"
            class="fs-3 text-primary m-0"
          ></ui-keenicon>
        </button>
      </label>
    }
  </div>
</div>
<div class="form-text">
  {{ description() }}
</div>
